import React from "react";
import ConfigurationOptionsForType from "./components/ConfigurationOptionsForType";
import { useState, useEffect, useRef } from "react";
import useAPI from "../../hooks/useAPI";
import useUtils from "../../hooks/useUtils";
import BaseProduct from "../BaseProduct";
import { Waypoint } from "react-waypoint";
import Price from "../Price";
import { Formik, Form, Field, ErrorMessage } from "formik";
import useSettings from "components/ConfiguratorApp/hooks/useSettings";

const ConfigurationOptions = ({
  baseProductId,
  onConfigurationUpdated,
  savedConfiguration,
  baseProduct,
  createOrUpdateConfigurationProductAndAddToCart,
  createOrUpdateConfigurationProductAndSendPDF,
  addToCartBtnText,
  isCreatingConfigurationAndAddingToCart,
}) => {
  const settings = useSettings();
  const pdfInitialValues = settings.dontRequireClientDetailsForPDF
    ? {
        email: "USER@USER.COM",
        tel: "00000000000",
        name: settings.customerDisplayName,
      }
    : { email: "", tel: "", name: "" };
  const [scrollingToCompatibilityIndex, setScrollingToCompatibilityIndex] =
    useState(null);
  const [showPDFModal, setShowPDFModal] = useState(false);
  const [successfullySubmitted, setSuccessfullySubmitted] = useState(false);
  const [configuration, setConfiguration] = useState({});
  const [totalCostOfOptions, setTotalCostOfOptions] = useState(0);
  const [compatibilities, setCompatibilities] = useState([]);
  const [selectedCompatibilityIndex, setSelectedCompatibilityIndex] =
    useState(0);
  const { API } = useAPI();
  const { calculateTotalCostOfConfiguration } = useUtils();
  const categoryNavRef = useRef(null);
  //TODO -> API GET /configuration/:baseProductId which will return the configuration order, e.g:
  // ["memory","cpu"]
  let configurationOrder = ["memory", "cpu"];
  let onUpdatedSelection = (category, selectedProducts) => {
    // console.log("updated categoryName", update.categoryName);
    // console.log("updated products", update.selectedProducts);
    console.log(
      "Updating config\n",
      configuration,
      "category\n",
      category,
      "selectedProducts\n",
      selectedProducts
    );
    let newConfig = { ...configuration };
    newConfig[category.name] = {
      category,
      selectedProducts,
    };
    console.log("Updating config", "new config", newConfig);
    setConfiguration(newConfig);
  };

  useEffect(() => {
    getAndSetCompatibilities();
  }, []);

  useEffect(() => {
    if (
      categoryNavRef.current &&
      categoryNavRef.current.children &&
      categoryNavRef.current.children.length > 0
    ) {
      //Set width of UL
      let totalWidth = 0;
      for (let i = 0; i < categoryNavRef.current.children.length; i++) {
        let child = categoryNavRef.current.children[i];
        let width = child.offsetWidth;
        console.log("i width", i, width);
        totalWidth += width;
        console.log("i width total", totalWidth);
      }
      categoryNavRef.current.style.width = totalWidth + 100 + 1 + "px";

      //scrollable
      // categoryNavRef.current.parentNode.style.overflowX = "scroll";
    }
  }, [compatibilities]);

  useEffect(() => {
    if (
      categoryNavRef.current &&
      categoryNavRef.current.children &&
      categoryNavRef.current.children.length > 0
    ) {
      let scrollLeft = 0;
      for (let i = 0; i < selectedCompatibilityIndex; i++) {
        let child = categoryNavRef.current.children[i];
        let width = child.offsetWidth;
        scrollLeft += width;
      }

      categoryNavRef.current.parentNode.scrollLeft = scrollLeft - 300; //Scroll into view but minus 300 so a lil more central. no anim - basic way for now
    }

    console.log("Selected compatibility index", selectedCompatibilityIndex);
  }, [selectedCompatibilityIndex]);

  useEffect(() => {
    console.log("savedConfiguration passed", savedConfiguration);
  }, [savedConfiguration]);

  useEffect(() => {
    console.log(
      "ConfigurationOptionsForType configuration updated",
      configuration
    );
    configuration &&
      onConfigurationUpdated &&
      onConfigurationUpdated(configuration);
  }, [configuration]);

  useEffect(() => {
    let totalCost = calculateTotalCostOfConfiguration(
      configuration,
      baseProduct
    );
    setTotalCostOfOptions(totalCost);
  }, [configuration]);

  const getAndSetCompatibilities = async () => {
    let data = await API.get(
      `/compatibilities/by-bc-product-id/${baseProductId}`
    );
    if (data.compatibilities) {
      //Remove compatibilities with no category
      let filteredCompatibilities = data.compatibilities.filter(
        (compatibility) => {
          return compatibility.category;
        }
      );
      setCompatibilities(filteredCompatibilities);
    }
  };

  const renderConfiguration = () => {
    let itemsToRender = [];
    itemsToRender.push(
      <div key="baseProduct">
        <ul className="config-summary-options">
          <li>
            <div>
              <div>(Base) {baseProduct.name} x1</div>
              {/* <div>£{baseProduct.price}</div> */}
              <div>
                <Price value={baseProduct.price}></Price>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
    for (let categoryName in configuration) {
      let selectedProducts = configuration[
        categoryName
      ].selectedProducts.filter((selectedProduct) => {
        return selectedProduct.qty > 0;
      });
      itemsToRender.push(
        <div key={`${categoryName}-selectedProducts`}>
          {/* <h5>{categoryName}</h5> */}
          <ul className="config-summary-options">
            {selectedProducts.map((product) => {
              return (
                <li key={product.id}>
                  <div>
                    <div>
                      {product.name} x{product.qty}
                    </div>
                    <div>
                      <Price value={product.price * product.qty}></Price>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
    return (
      <div
        style={{
          maxHeight: "calc(100vh - 530px)",
          overflowY: "auto",
          paddingLeft: "2px",
          paddingRight: "5px",
        }}
      >
        {itemsToRender}
      </div>
    );
  };

  const onEnteredCategory = (e, catIndex) => {
    console.log("onEnteredCategory", e, catIndex);
    if (scrollingToCompatibilityIndex === catIndex) {
      setSelectedCompatibilityIndex(catIndex);
      setScrollingToCompatibilityIndex(null);
    } else if (!scrollingToCompatibilityIndex) {
      setSelectedCompatibilityIndex(catIndex);
    }
  };

  const scrollToNextCompatibilityIndex = () => {
    let nextCompatibilityIndex = selectedCompatibilityIndex + 1;
    if (nextCompatibilityIndex < compatibilities.length) {
      //Scroll to it
      scrollToCompatibilityIndex(nextCompatibilityIndex);
    } else if (nextCompatibilityIndex === compatibilities.length) {
      scrollIntoViewById("sbFinalTotal");
    }
  };

  const scrollToCompatibilityIndex = (compatibilityIndex) => {
    let eleId = compatibilities[compatibilityIndex]?.compatibility?._id;
    scrollIntoViewById(eleId);
  };

  const scrollIntoViewById = (eleId) => {
    let ele = document.getElementById(eleId);
    if (ele) {
      ele.scrollIntoView({
        behavior: "smooth",
        // block: "end",
        // inline: "nearest",
      });
    }
  };

  const AddToCartBtn = () => {
    return settings && settings.allowAddToCart ? (
      <button
        style={{ marginTop: "10px" }}
        className="sb-btn sb-btn-style-solid sb-width-full"
        onClick={createOrUpdateConfigurationProductAndAddToCart}
      >
        {addToCartBtnText}
      </button>
    ) : null;
  };

  const DownloadPDFBtn = () => {
    return (
      <button
        className="sb-btn sb-width-full"
        onClick={() => {
          setShowPDFModal(true);
        }}
      >
        Download PDF
      </button>
    );
  };

  return (
    <div className="sb-config">
      <div className="sb-config-category-options">
        {/* <h2>Configuration options:</h2> */}

        <BaseProduct baseProduct={baseProduct} />

        {/* List of cats */}
        <div className="sb-config-categories-nav-wrapper">
          <ul className="sb-config-categories-nav" ref={categoryNavRef}>
            {compatibilities.map((compatibility, index) => {
              return (
                <li
                  className={
                    selectedCompatibilityIndex == index ? "sb-state-active" : ""
                  }
                >
                  <a
                    // href={`#${index}`}
                    onClick={() => {
                      // setSelectedCompatibilityIndex(index);
                      setScrollingToCompatibilityIndex(index);
                      scrollToCompatibilityIndex(index);
                    }}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    {compatibility.category.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div>
          {/* Compatibility Options */}
          {compatibilities.map((compatibility, index) => {
            // console.log(
            //   "compatibility",
            //   compatibility,
            //   "savedConfig",
            //   savedConfiguration
            // );

            let savedSelectedProducts = null;
            if (
              savedConfiguration &&
              savedConfiguration[compatibility.category.name]
            ) {
              savedSelectedProducts =
                savedConfiguration[compatibility.category.name]
                  .selectedProducts;
            }

            return (
              <Waypoint
                bottomOffset="70%"
                onEnter={(e) => {
                  onEnteredCategory(e, index);
                }}
              >
                <div>
                  <a
                    name={index}
                    style={{
                      position: "relative",
                      top: "-100px",
                    }}
                  ></a>
                  <ConfigurationOptionsForType
                    id={compatibility.compatibility._id}
                    key={compatibility.compatibility._id}
                    baseProductId={baseProductId}
                    // type={configurationType}
                    onUpdatedSelection={onUpdatedSelection}
                    category={compatibility.category}
                    products={compatibility.compatibility.products}
                    canMixPartCodes={
                      compatibility.compatibility.canMixPartCodes
                    }
                    maxUnitCount={compatibility.compatibility.maxCountUnit}
                    savedSelectedProducts={savedSelectedProducts}
                    index={index}
                    expandItem={selectedCompatibilityIndex === index}
                    onSelectedMaxOptions={scrollToNextCompatibilityIndex}
                  />
                </div>
              </Waypoint>
            );
          })}
        </div>
        {/* <hr /> */}

        <div className="sb-final" id="sbFinalTotal">
          <div>
            <h1>
              Total: <Price value={totalCostOfOptions} />
            </h1>
          </div>
          <div>
            {!isCreatingConfigurationAndAddingToCart ? (
              <AddToCartBtn />
            ) : (
              <p style={{ margin: 0, padding: "15px" }}>
                "Creating your configuration, please wait..."
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="sb-config-selection">
        <h6>Your configuration:</h6>
        <div>
          <p style={{ marginBottom: "5px" }}>
            <strong>{baseProduct.name} configured with:</strong>
          </p>
          {renderConfiguration()}
          <h6 style={{ textAlign: "right" }}>
            <strong>
              Total Cost: <Price value={totalCostOfOptions} />
            </strong>
          </h6>
          {!isCreatingConfigurationAndAddingToCart ? (
            <div>
              <DownloadPDFBtn />
              <AddToCartBtn />
            </div>
          ) : (
            "Creating your configuration, please wait..."
          )}
          {settings.showTouchPoints && (
            <div
              style={{
                margin: "15px 0px",
                backgroundColor: "#eaeaea",
                padding: "30px",
              }}
            >
              <h5>Get in touch for discounted pricing</h5>
              <a
                className="sb-btn"
                href="/contact-us"
                style={{
                  margin: "5px 0px",
                  display: "block",
                  textAlign: "center",
                }}
              >
                Chat with our team
              </a>
            </div>
          )}
        </div>
        {/* {JSON.stringify(configuration, null, 2)} */}
      </div>
      {showPDFModal && (
        <div className="sb-pdf-modal">
          <div className="sb-pdf-modal-content">
            <div style={{ textAlign: "right" }}>
              <button
                onClick={() => {
                  setShowPDFModal(false);
                }}
              >
                Close
              </button>
            </div>
            <h4>Download your PDF configuration</h4>
            {successfullySubmitted ? (
              <div>
                <p>
                  Thank you, your PDF is on it's way into your e-mail inbox.
                  <br />
                  {!settings.dontRequireClientDetailsForPDF && (
                    <span>
                      A member of sales will be in contact to discuss any
                      queries you may have.
                    </span>
                  )}
                </p>
              </div>
            ) : (
              <Formik
                initialValues={pdfInitialValues}
                validate={(values) => {
                  const errors = {};
                  if (!values.email) {
                    errors.email = "Required";
                  } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                      values.email
                    )
                  ) {
                    errors.email = "Invalid email address";
                  }
                  return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  createOrUpdateConfigurationProductAndSendPDF(
                    values.email,
                    values.tel,
                    values.name,
                    () => {
                      setSubmitting(false);
                      setSuccessfullySubmitted(true);
                    }
                  );
                }}
              >
                {({ isSubmitting }) => (
                  <Form id="download_pdf_config">
                    {settings.dontRequireClientDetailsForPDF ? (
                      <p>
                        Click below and your PDF will be sent to your e-mail
                        address.
                      </p>
                    ) : (
                      <p>
                        Please enter your details below and a PDF of your
                        configuration will be e-mailed to you.
                      </p>
                    )}
                    <div>
                      {!settings.dontRequireClientDetailsForPDF && (
                        <div>
                          <h6>Name</h6>
                          <Field
                            type="text"
                            name="name"
                            required
                            placeholder="Enter your name"
                          />
                          <h6>E-mail</h6>
                          <Field
                            type="email"
                            name="email"
                            required
                            placeholder="Enter your email"
                          />
                          <ErrorMessage name="email" component="div" />
                          <h6>Tel</h6>
                          <Field
                            type="tel"
                            name="tel"
                            required
                            placeholder="Enter your phone number"
                          />
                          <ErrorMessage name="password" component="div" />
                          <br />
                          <br />
                        </div>
                      )}
                      <button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Generating your PDF..." : "Submit"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigurationOptions;
